import PopOut from '../PopOut/PopOut'
import classes from './Badge.module.scss'
import type { ReactNode } from 'react'

export interface Props {
  children?: ReactNode
  label: string
}

const Badge = ({
  children,
  label
}: Props) => {
  const triggerBadgeButton = (ref: any, onClick: () => void) =>
    <button
      aria-label={label}
      className={classes.Badge}
      onClick={onClick}
      ref={ref}
      type='button'
    >
      {label}
    </button>

  if (!children) {
    return (
      <span className={classes.Badge}>
        {label}
      </span>
    )
  }

  return (
    <PopOut
      placement='bottom-start'
      trigger={triggerBadgeButton}
    >
      <div className={classes.PopOut}>
        {children}
      </div>
    </PopOut>
  )
}

export default Badge
